import * as React from "react"

import { GlobalState } from "../../../store"
import { useAppDispatch, useAppSelector } from "../../../hooks"

import { fetchFields } from "../slice"
import { Field } from "./Field"

export interface OwnProps {
    fieldId: string
}

type Props = OwnProps

export const ItemDetailField = ({ fieldId }: Props): JSX.Element => {
    const { fields, isLoading, isInitialized } = useAppSelector(
        (state: GlobalState) => state.fields,
    )
    const dispatch = useAppDispatch()

    React.useEffect(() => {
        if (!isInitialized && !isLoading) {
            dispatch(fetchFields())
        }
    }, [isInitialized, isLoading])

    const field = fields[fieldId] ?? null

    return <Field field={field} isLoading={isLoading} />
}

export default ItemDetailField
